import { jsx as _jsx } from "react/jsx-runtime";
export function ArrowDropDownIcon({ size, className }) {
    return (_jsx("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", height: size + 'px', viewBox: "0 -960 960 960", width: size + 'px', children: _jsx("path", { d: "M480-371.69 293.69-556h372.62L480-371.69Z" }) }));
}
//# sourceMappingURL=ArrowDropDownIcon.js.map